// extracted by mini-css-extract-plugin
export default {"billOverview":"bill-index_billOverview__aUEXs","groupLinks":"bill-index_groupLinks__9D5mf","documentLinks":"bill-index_documentLinks__7zVI0"};